var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebFooterFbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0396 36.6004H17.9604C8.05714 36.6004 0 28.5409 0 18.6348V18.5555C0 8.64937 8.05714 0.589844 17.9604 0.589844H18.0396C27.9429 0.589844 36 8.64937 36 18.5555V18.6348C36 28.5409 27.9429 36.6004 18.0396 36.6004ZM17.9604 1.80877C8.72857 1.80877 1.21856 9.321 1.21856 18.5555V18.6348C1.21856 27.8693 8.72857 35.3815 17.9604 35.3815H18.0396C27.2714 35.3815 34.7814 27.8693 34.7814 18.6348V18.5555C34.7814 9.321 27.2714 1.80877 18.0396 1.80877H17.9604Z",
    fill: "#059669"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4237 14.5568V18.3464H25.1103L24.3682 23.4513H20.4237V35.2127C19.6328 35.3224 18.8237 35.3797 18.0024 35.3797C17.0544 35.3797 16.1234 35.3041 15.2168 35.1578V23.4513H10.8945V18.3464H15.2168V13.7097C15.2168 10.833 17.5479 8.5 20.4249 8.5V8.50244C20.4334 8.50244 20.4408 8.5 20.4493 8.5H25.1115V12.9149H22.0651C21.1597 12.9149 20.4249 13.6499 20.4249 14.5556L20.4237 14.5568Z",
    fill: "#059669"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebFooterFbIcon);
export default __webpack_public_path__ + "static/media/web_footer_FB_icon.c604ade46cdcb971a7cddcb80805e823.svg";
export { ForwardRef as ReactComponent };